// extracted by mini-css-extract-plugin
export var dropdown = "_or-1";
export var hidden = "_or-0";